export default "__VITE_ASSET__BgKc0YDk__"